import styled from 'styled-components';
import { Label } from 'common/baseComponents'
import { SIZE, LAYERS } from 'common/sizes';

import { LABEL, LIST } from 'common/base';
import { DEFAULT_FONT_FAMILY } from 'common/constants';

interface IStyleProps {
    bgColor: string;
    selectedTab: string;
}
  
interface IGlobalContainerStyleProps {
    selectedTab: string;
}

export const MainContainer = styled.div`
    padding: 22px 0px 50px 0px;
    width: 100%;
    display: flex;
    flex-direction: column;
`;

export const GlobalContainer = styled.div`
    box-shadow: ${(props: IGlobalContainerStyleProps) => (props.selectedTab === "entire" ? "-2px 4px 15px 0 rgba(0, 0, 0, 0.15)" : "")};
    margin: 0px 22px 0px 22px;
`;

export const WidgetContainer = styled.div`
    position: relative;
    margin: ${(props: IStyleProps) => (props.selectedTab === "entire" ? "0px 0px 0px 0px" : "0px 0px 22px 0px")};
    padding: 21px 25px 21px 25px;
    box-shadow: ${(props: IStyleProps) => (props.selectedTab !== "entire" ? "-2px 4px 15px 0 rgba(0, 0, 0, 0.15)" : "")};
    background-color: ${(props: IStyleProps) => (props.bgColor)};
    border-radius:: ${(props: IStyleProps) => (props.selectedTab === "entire" ? "0px" : "5px")};
`;

export const TitleContainer = styled.div`
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 15px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #a5a5a5;
    margin-bottom: 20px;
`;

